import * as angular from 'angular';
import { downgradeInjectable } from '@angular/upgrade/static';
import { ReportEditorFacade } from '@mode/report-editor/domain';
import { ViewDataModalFacade } from '@mode/reports/domain';

export const DowngradedReportEditorDomainModule = angular
  .module('downgraded-report-editor-domain', [])
  .service('ReportEditorFacade', downgradeInjectable(ReportEditorFacade))
  .service('ViewDataModalFacade', downgradeInjectable(ViewDataModalFacade)).name;
